import { Outlet } from "react-router";

export function SampleRoute() {
  return <Outlet />;
}
